import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <div className="image-row">
        <img src="/1.png" alt="Tattoo Art 1" />
        <img src="/2.png" alt="Tattoo Art 2" />
        <img src="/3.png" alt="Tattoo Art 3" />
      </div>
      <div className="decorative-box">
        <h1>Welcome to Evil District Tattoos</h1>
        <p>
          At <strong>Evil District Tattoos</strong>, we specialize in dark, gothic tattoo artistry that pushes the boundaries of creativity. 
          Established in <strong>2017</strong>, we have been at the forefront of the tattooing industry, earning several coveted awards at 
          prestigious tattoo conventions across the nation.
        </p>
        <p>
          Our talented team also includes a skilled artist who specializes in 
          <strong> cover-ups</strong> and <strong>cosmetic surgery cover-ups</strong>, helping you reclaim confidence with beautiful designs.
        </p>
      </div>
    </div>
  );
};

export default Home;
